
export class ProcessorFieldOpKey {
code: string;
order: number | null;
}

